
import { configureStore } from "@reduxjs/toolkit";
import  authReducer  from '../reducers/auth/authReducer';
import contractsReducer from "../reducers/contracts/contractsReducer";
import uiReducer from "../reducers/ui/uiReducer";
import mapReducer from "../reducers/map/mapReducer";
import nodesReducer from "../reducers/nodes/nodesReducer";
import panelsReducer from "../reducers/panels/panelsReducer";
import gatewaysReducers from "../reducers/gateways/gatewaysReducers";
import usersReducer from "../reducers/users/usersReducer";
import socketReducer from "../reducers/socket/socketReducer";
import panelsDynamicProfilesReducer from "../reducers/dynamicLighting/panelsDynamicProfilesReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    contracts: contractsReducer,
    nodes: nodesReducer,
    panels: panelsReducer,
    gateways: gatewaysReducers,
    ui: uiReducer,
    users: usersReducer,
    map: mapReducer,
    socket: socketReducer,
    panelsDynamicProfiles: panelsDynamicProfilesReducer
  },
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: true, 
  //devTools: process.env.NODE_ENV !== 'production',
});

//export default store;


